import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module';
import Config from './config.json';
import {CUSTOM_TRANSLATION_KEY} from "./services/i18n";
import CryptoJS from 'crypto-js'

const tagManagerArgs = {
    gtmId: Config.GTM_TAG_ID,
};

tagManagerArgs.gtmId.length > 0 && TagManager.initialize(tagManagerArgs);

const hashJSON = (json:any) => {
    const jsonString = JSON.stringify(json);
    return CryptoJS.SHA256(jsonString).toString(CryptoJS.enc.Hex);
};

const checkTranslations = async () => {
    try {
        const localStorageData = localStorage.getItem(CUSTOM_TRANSLATION_KEY);
        const localStorageHash = localStorageData ? hashJSON(JSON.parse(localStorageData)) : '';

        const response = await fetch(Config.CUSTOM_TRANSLATION_FILE);
        const fetchedTranslations = await response.json();

        const fetchedHash = hashJSON(fetchedTranslations);

        if (fetchedHash !== localStorageHash) {

            setTimeout(()=>{
                localStorage.setItem(CUSTOM_TRANSLATION_KEY, JSON.stringify(fetchedTranslations));
                window.location.reload();
            },1000)

        }
    } catch (e) {
        console.info("Error during fetch or hash comparison:", e);
    }
};

const startApp = async () => {
    await checkTranslations()
    ReactDOM.render(<App/>, document.getElementById('root'));
}

startApp()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
